import Axios from "axios";
import { AgCharts, AgChartProps } from "ag-charts-react";
import { useEffect, useState } from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";

interface IStat {
  logDate: Date;
  nrOfInternalUsers: number;
  nrOfExternalUsers: number;
}

const UserChart = () => {
  const [stats, setStats] = useState<IStat[]>([]);

  useEffect(() => {
    async function fetchData() {
      const res = await Axios.get("/api/stats");
      const statsFetch: IStat[] = res.data;

      setStats(statsFetch);
    }

    fetchData();
  }, []);

  const options: AgChartProps["options"] = {
    data: stats.map((stat) => ({
      ...stat,
      logDate: new Date(stat.logDate),
    })),
    title: {
      text: "Users logged in last 30 days",
    },
    axes: [
      {
        type: "time",
        position: "bottom",
      },
      {
        type: "number",
        position: "left",
        title: {
          text: "Number of users",
        },
      },
    ],
    legend: {
      position: "right",
    },
    series: [
      {
        type: "area",
        xKey: "logDate",
        yKey: "nrOfInternalUsers",
        yName: "Multiconsult employees",
        fill: "#ff9800",
        stroke: "#ff9800",
        stacked: true,
      },
      {
        type: "area",
        xKey: "logDate",
        yKey: "nrOfExternalUsers",
        yName: "External users",
        stacked: true,
      },
    ],
  };

  return (
    <Card className="m-3">
      <CardBody>
        <CardTitle tag="h3">User Statstics</CardTitle>
        <CardSubtitle tag="h6" className="mb-2 text-muted" />
        <AgCharts options={options} />
      </CardBody>
    </Card>
  );
};

export default UserChart;
